module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAEAQMAAAB4CLc+AAAABlBMVEUAAABydnzSxOaWAAAAAXRSTlMAQObYZgAAABBJREFUCNdjEGCwYKhh+AcABAIBw16BkcgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_arrowUp.png
// module id = kTkj
// module chunks = 9